import { render, staticRenderFns } from "./grid-event.vue?vue&type=template&id=2aa26ace&scoped=true&"
import script from "./grid-event.vue?vue&type=script&lang=js&"
export * from "./grid-event.vue?vue&type=script&lang=js&"
import style0 from "./grid-event.vue?vue&type=style&index=0&id=2aa26ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa26ace",
  null
  
)

export default component.exports